// Shared styles for the blocks ported from the Happy Hour site. Values mirror
// that site's design system: the rewards-page CTA red, black text, the RLN
// cream band, Antonio for display headings, nobel for everything else and
// alkaline for script accents. Sizes are in pixels, as that site renders them.

.tokens {
    --hh-lobster: #db0e0a;
    --hh-lobster-deep: #b40c08;
    --hh-cream: #fbf2e5;
    --hh-panel: #f3e6c0;
    --hh-background: oklch(98.5% 0.006 95deg);
    --hh-card: #ffffff;
    --hh-foreground: #000000;
    --hh-muted-foreground: oklch(47% 0.03 255deg);
    --hh-font-display:
        antonio, "Arial Narrow", "Helvetica Neue", arial, sans-serif;
    --hh-font-body:
        nobel, "Nobel Regular", "Helvetica Neue", helvetica, arial, sans-serif;
    --hh-font-script: alkaline, "Brush Script MT", cursive;

    color: var(--hh-foreground);
    font-family: var(--hh-font-body);
    text-align: center;
}

// Section wrapper: page background or the cream band.
.page {
    background-color: var(--hh-background);
}

.cream {
    background-color: var(--hh-cream);
}

// Content column: 1152px, 24px side padding (40px from 1024px).
.container {
    margin: 0 auto;
    max-width: 72rem;
    padding: 0 24px;

    @media (min-width: 1024px) {
        padding: 0 40px;
    }
}

// Headlines: Antonio Medium, uppercase, tight leading.
.display {
    font-family: var(--hh-font-display);
    font-weight: 500;
    letter-spacing: 0.01em;
    line-height: 0.95;
    margin: 0;
    text-transform: uppercase;
}

// Section titles: 52px on phones, 96px from 1024px, in the CTA red.
.title {
    composes: display;
    color: var(--hh-lobster);
    font-size: 52px;

    @media (min-width: 1024px) {
        font-size: 96px;
    }
}

// Script accents: alkaline 600.
.script {
    font-family: var(--hh-font-script);
    font-weight: 600;
    line-height: 1;
    margin: 0;
    text-transform: none;
}

// Small uppercase labels: nobel bold.
.eyebrow {
    font-family: var(--hh-font-body);
    font-weight: 700;
    letter-spacing: 0.04em;
    margin: 0;
    text-transform: uppercase;
}

// The red CTA as redlobster.com/rewards renders it: 3px corners, 14px type up
// to 768px, 16px above it.
.cta {
    align-items: center;
    background-color: var(--hh-lobster);
    border: 0;
    border-radius: 3px;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    font-family: var(--hh-font-body);
    font-size: 14px;
    font-weight: 700;
    justify-content: center;
    line-height: normal;
    padding: 6px 12px;
    text-decoration: none;
    text-transform: uppercase;
    transition: background-color 150ms ease-in-out;
    white-space: nowrap;

    &:hover,
    &:focus {
        background-color: var(--hh-lobster-deep);
    }

    @media (min-width: 769px) {
        font-size: 16px;
        padding: 12px 20px;
    }
}

// Hero buttons stay at 16px on phones too.
.ctaLarge {
    composes: cta;
    font-size: 16px;
}
